import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BusinessSetup = () => {
  const [businessInfo, setBusinessInfo] = useState({
    name: '',
    logo: null
  });
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo' && files[0]) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBusinessInfo(prev => ({
          ...prev,
          [name]: reader.result
        }));
      };
      reader.readAsDataURL(files[0]);
    } else {
      setBusinessInfo(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!businessInfo.name) {
      alert('Per favore, inserisci il nome dell\'attività. Il logo è facoltativo.');
      return;
    }
    localStorage.setItem('businessInfo', JSON.stringify(businessInfo));
    navigate('/setup/card-layout');
  };

  return (
    <div className="container">
      <div className="step-container">
        <div className="step-header">
          <span className="badge">Step 1</span>
          <h2>Configura la tua attività</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nome dell'attività</label>
            <input
              type="text"
              id="name"
              name="name"
              value={businessInfo.name}
              onChange={handleInputChange}
              placeholder="Es. Bar del Centro"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="logo">Logo dell'attività</label>
            <input
              type="file"
              id="logo"
              name="logo"
              onChange={handleInputChange}
              accept="image/*"
            />
          </div>
          {businessInfo.logo && (
            <img src={businessInfo.logo} alt="Logo preview" style={{ maxWidth: '200px', marginTop: '10px', borderRadius: '12px', border: '1px solid #e5e7eb' }} />
          )}
          <div style={{ marginTop: '16px' }}>
            <button type="submit" className="btn btn-primary">Avanti</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BusinessSetup;